<template>
  <div class="food-manage">
    <el-form ref="addStockForm" :model="addStockForm" :rules="addStockFormRule">
      <el-form-item label="总股数" prop="exercise_title">
        <p>{{ currentStock/100/10000 | formatMoney }}万股</p>
      </el-form-item>
      <el-form-item label="总金额">
        <el-input v-model="addStockForm.marketCapitalization" placeholder="请输入金额" style="width: 150px;margin-left:20px" /><span>万元</span>
      </el-form-item>
      <el-form-item label="附件">
        <UploadImg :photo="addStockForm.attachment" @updateImg="updateImg" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="fnSubmitCreate">确定</el-button>
    </div>
  </div>

</template>
<script>
import Tool from '@/assets/js/tool.js'

import commondata from '@/utils/commondata'
import UploadImg from '@/components/toolbar/UploadImg.vue'

const defaultAddStockForm = {
  marketCapitalization: '',
  attachment: ''
}

export default {
  name: 'CreateStockPrice',
  components: {
    UploadImg
  },
  filters: {
    formatMoney: function(val) {
      return Tool.formatMoney(val, true)
    }
  },
  data() {
    return {
      lists: [],
      stockTypes: commondata.STOCK_TYPE,
      addStockForm: Object.assign({}, defaultAddStockForm),
      addStockFormRule: {},
      currentStock: 0
    }
  },
  created() {
    console.log(Tool)
    this.fnGetLatestPrice()
  },
  methods: {
    fnGetLatestPrice() {
      this.$http.getLatestSharePrice().then(res => {
        this.currentStock = parseFloat(res.data.capital_stock || '0')
      })
    },
    updateImg(photo) {
      this.addStockForm.attachment = photo
    },
    fnSubmitCreate() {
      if (!this.addStockForm.attachment || !this.addStockForm.marketCapitalization) {
        this.$message({
          type: 'error',
          message: '请填写相关信息'
        })
        return
      }
      if (!Tool.isNumber(this.addStockForm.marketCapitalization)) {
        this.$message({
          type: 'error',
          message: '请输入数字'
        })
        return
      }
      this.addStockForm.marketCapitalization = this.addStockForm.marketCapitalization * 10000
      this.$http.recordSharePrice(this.addStockForm).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addStockForm = {}
          this.addStockForm = Object.assign({}, defaultAddStockForm)
          this.$emit('successCBK')
        }
      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
